<template>
  <Modal
    id="user-delete"
    :hide-footer="true"
    no-stacking>
    <template v-slot:modal-title>
      <span class="modal-title">Удаление пользователя</span>
    </template>
    <div slot class="flex flex-col items-stretch p-8">
      <p class="text-center text-16px leading-22px mb-6 text-muted">
        Вы действительно хотите удалить данного пользователя?
      </p>
      <div class="flex flex-row align-self-stretch space-x-2">
        <button
          class="btn btn-xs btn-outline-primary flex-grow"
          @click="$bvModal.hide('user-delete')">Отмена</button>
        <button
          class="btn btn-xs btn-primary flex-grow"
          @click="onDelete">Да, удалить</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  name: 'UserDeleteModal',
  components: {
    Modal,
  },
  methods: {
    onDelete() {
      this.$emit('delete');
      this.$bvModal.hide('user-delete');
    },
  },
};
</script>
